import { arePropertyValuesEqual } from "src/services/property/arePropertyValuesEqual";
import { CaseSummary } from "src/types/case";

import { CasePropertyDiff } from "./AlertCaseVersionsDiffModal.types";
import { getCaseVersionsPropertyDiffs_ } from "./getCaseVersionsPropertyDiffs";

export const hasCaseVersionsPropertyChanged = (diff: CasePropertyDiff) => {
  return Object.values(diff.versions).some((version) => {
    if (!version) return false;
    // Check if there's a change type (addition, deletion, modification)
    if (version.changeType && version.changeType !== "unchanged") {
      return true;
    }
    // Fallback: compare properties if both exist
    if (version.property && diff.original.property) {
      return !arePropertyValuesEqual(version.property, diff.original.property);
    }
    // If one exists and the other doesn't, it's a change
    return (version.property !== null) !== (diff.original.property !== null);
  });
};

export const hasCaseVersionsChanged = (
  originalCase: CaseSummary,
  versions: Record<string, CaseSummary | null>
) => {
  const diffs = getCaseVersionsPropertyDiffs_(originalCase, versions);
  return diffs.some(hasCaseVersionsPropertyChanged);
};
